import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MobileIdentificationCredentialActionReasonType } from '../../MobileIdentification/models/enums/mobile-identification-credential-action-reason-type.enum';
import { MobileIdentificationCredentialActionType } from '../../MobileIdentification/models/enums/mobile-identification-credential-action-type.enum';
import { MVMDropDownModel } from '../../shared/models/mvm-drop-down/mvm-drop-down.model';

export class MobileIdentificationCredentialActionRequestModalContext {
    constructor(
        public actionType: number
    ) { }
}

@Component({
    selector: 'mobile-identification-credential-action-request-modal',
    templateUrl: './mobile-identification-credential-action-request-modal.html'
})
export class MobileIdentificationCredentialActionRequestModalComponent implements OnInit {
    public requestForm: UntypedFormGroup;
    public reasonTypeIdOptions: MVMDropDownModel<number>[] = new Array<MVMDropDownModel<number>>();
    public actionName: string;

    private mobileIdentifiationCredentialActionType = new MobileIdentificationCredentialActionType();
    private mobileIdentificationCredentialActionReasonType = new MobileIdentificationCredentialActionReasonType();

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: MobileIdentificationCredentialActionRequestModalContext,
        private dialogRef: MatDialogRef<MobileIdentificationCredentialActionRequestModalComponent>,
        private fb: UntypedFormBuilder,
    ) { }

    public ngOnInit(): void {
        this.setActionTypeInformation();
        this.requestForm = this.fb.group({
            reasonTypeId: [null, Validators.required]
        });
    }

    private setActionTypeInformation() {
        let adotValue: number;
        let customerValue: number;
        switch (this.data.actionType) {
            case this.mobileIdentifiationCredentialActionType.Resume.id:
                this.actionName = 'resuming';
                adotValue = this.mobileIdentificationCredentialActionReasonType.IssuerIssueResolved.id;
                customerValue = this.mobileIdentificationCredentialActionReasonType.CustomerIssueResolved.id;
                break;
            case this.mobileIdentifiationCredentialActionType.Unlink.id:
                this.actionName = 'unlinking';
                adotValue = this.mobileIdentificationCredentialActionReasonType.IssuerIssueResolved.id;
                customerValue = this.mobileIdentificationCredentialActionReasonType.CustomerIssueResolved.id;
                break;
            case this.mobileIdentifiationCredentialActionType.Suspend.id:
            default:
                this.actionName = 'pausing';
                adotValue = this.mobileIdentificationCredentialActionReasonType.IssuerInitiated.id;
                customerValue = this.mobileIdentificationCredentialActionReasonType.CustomerInitiated.id;
                break;
        }

        this.addReasonTypeIdOption('Customer', customerValue);
        this.addReasonTypeIdOption('ADOT', adotValue);
    }

    public onAcceptClick(): void {
        this.dialogRef.close(this.requestForm.get('reasonTypeId').value);
    }

    public onCancelClick(): void {
        this.dialogRef.close();
    }

    private addReasonTypeIdOption(label: string, value: number): void {
        const reasonTypeIdOption: MVMDropDownModel<number> = {
            label: label,
            value: value
        };

        this.reasonTypeIdOptions.push(reasonTypeIdOption);
    }
}
